import { ImageProvider } from '../../types/image/image-provider.type';

export class Image {
    constructor(
        public url: string,
        public source?: ImageProvider,
        public focusPoint?: string
    ) {}
}
